import { makeStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles(theme => ({
  card: {
    maxWidth: 345,
    width: "100%"
  },
  media: {
    marginLeft: "auto",
    marginRight: "auto",
    margin: " 10px auto"
  },
  minSize: {
    minWidth: '100px',
    minHeight: '85px',
  },

  cardInput: {
    boxShadow: "0 2px 3px 0 rgba(0, 0, 0, 0.2), 0 4px 8px 0 rgba(0, 0, 0, 0.19)",
    borderRadius: "7px",
    cursor: "pointer",
    "&:hover": {
      opacity: 0.8,
      boxShadow: "0 4px 6px 0 rgba(0, 0, 0, 0.37), 0 6px 10px 0 rgba(0, 0, 0, 0.35)"
    },
    backgroundColor: theme.kooee.backgrounds.primary,
    [theme.breakpoints.down("sm")]: {
      padding: "1rem"
    },
    padding: "3rem 2rem 1rem 2rem",
    position: "relative",
    margin: "10px auto",
    [theme.breakpoints.up("md")]: {
      width: "10vw",
      height: "8vw"
    },
    [theme.breakpoints.down("md")]: {
      width: "10vw",
      height: "10vw"
    },
    "@media only screen and (min-device-width : 768px) and (max-device-width : 1024px) and (-webkit-min-device-pixel-ratio: 1)": {
      width: "10vmin",
    }
  },
  withIcon: {
    [theme.breakpoints.down("sm")]: {
      padding: "2rem 1.8rem 1rem"
    }
  },
  selected: {
    border: "3px solid #FB7906",
    backgroundColor: theme.kooee.backgrounds.secondary,
    color: theme.kooee.titles.primary,
    "& > h6": {
      color: theme.kooee.titles.primary
    }
  },
  imageWrapper: {
    position: "relative"
  },
  cardImage: {
    width: "100%",
    height: "50px",
    position: "absolute",
    margin: "auto",
    left: 0,
    right: 0,
    fill: "red"
  },
  title: {
    position: "absolute",
    left: 0,
    right: 0,
    fontSize: "1rem",
    [theme.breakpoints.up("md")]: {
      top: "1em"
    },
    [theme.breakpoints.between("sm", "md")]: {
      bottom: "16vmin"
    },
    [theme.breakpoints.down("sm")]: {
      top: "0.3em"
    },
    color: theme.kooee.text.primary
  },
  subTitle: {
    position: "absolute",
    left: 0,
    right: 0,
    bottom: "0.2em",
    "@media only screen and (min-device-width : 768px) and (max-device-width : 1024px) and (-webkit-min-device-pixel-ratio: 1)": {
      fontSize: "1.5em"
    },
    color: theme.kooee.text.primary
  },
  mainTitle: {
    "@media only screen and (min-device-width : 768px) and (max-device-width : 1024px) and (-webkit-min-device-pixel-ratio: 1)": {
      fontSize: "2em"
    },
    color: theme.kooee.text.primary,
    fontWeight: 600
  },
  disabled: {
    opacity: 0.4,
    boxShadow: "none",
    cursor: "not-allowed",
    "&:hover": {
      opacity: 0.4,
      boxShadow: "none"
    }
  },
  labelImageWrapper: {
    "& > img": {
      width: "4em",
      position: "ABSOLUTE",
      top: "-1em",
      right: "-1em",
      [theme.breakpoints.down("sm")]: {
        right: "-0.5em"
      },
      "@media only screen and (min-device-width : 768px) and (max-device-width : 1024px) and (-webkit-min-device-pixel-ratio: 1)": {
        fontSize: "2em",
        right: " -0.5em",
        width: "3em"
      }
    }
  },
  imageCardWrapper: {
    position: "relative"
  }
}));
